module.exports = __webpack_public_path__ + "static/media/child-logo.9e9b00ad.svg";